import cn from 'classnames'
import * as React from 'react'

import { CrossIcon, CheckIcon } from '../../icon'

import { ErrorText, IFormInput, Label } from '..'

import styles, { inputWithoutIcon } from './text.module.scss'
import { FormattedMessage } from 'react-intl'

interface IText<T> extends IFormInput<T> {
  type?: 'text' | 'email' | 'tel'
  textArea?: boolean
  hideIcon?: boolean
  wrapperClassName?: string
}

const icons = {
  invalid: <CrossIcon className={styles.icon} theme="danger" />,
  unknown: '',
  valid: <CheckIcon active className={styles.icon} />,
}

export default function Text<T>({
  errorCollapse = 'fixed',
  errorMessage = '',
  input,
  label = '',
  name,
  type = 'text',
  valid = 'unknown',
  validate,
  validateOnBlur,
  hideIcon = false,
  textArea,
  wrapperClassName,
  ...rest
}: IText<T> & React.InputHTMLAttributes<HTMLInputElement>) {
  if (typeof name !== 'string') {
    throw new TypeError('Name must be a string')
  }

  const isInvalid = valid === 'invalid'

  return (
    <div className={cn(styles.root, wrapperClassName)}>
      {label && (
        <Label input={input} name={name}>
          {label} {!rest.required && <FormattedMessage defaultMessage="(frivilligt)" id="input.optional-text" />}
        </Label>
      )}

      {textArea ? (
        <textarea
          {...input[type]({ name, validate, validateOnBlur })}
          className={cn([styles.input, isInvalid && styles.error, hideIcon && inputWithoutIcon])}
          placeholder={rest.required && rest.placeholder ? rest.placeholder + ' *' : rest.placeholder}
        />
      ) : (
        <input
          {...input[type]({ name, validate, validateOnBlur })}
          className={cn([styles.input, isInvalid && styles.error, hideIcon && inputWithoutIcon])}
          {...rest}
          placeholder={rest.required && rest.placeholder ? rest.placeholder + ' *' : rest.placeholder}
        />
      )}

      {!hideIcon && icons[valid]}
      {(errorCollapse === 'fixed' || isInvalid) && <ErrorText>{isInvalid && errorMessage}</ErrorText>}
    </div>
  )
}
